<template>
  <div class="compagin-pop-up-wrapper">
    <div class="popup-iqos">
      <IQOS title="Створення рекламної кампанії">
        <div>
          <BlackSelect
            class="mb-10"
            :readonly="false"
            placeholder="Кількість кодів"
          /><BlackSelect
            :readonly="false"
            placeholder="Кількість застосувань"
          />
          <div class="iqos-group-item">
            <BlackSelect class="mb-10" :readonly="false" placeholder="Тип" />
            <BlackSelect
              class="mb-10"
              :readonly="false"
              placeholder="Оберіть страву"
            />
            <BlackSelect
              :readonly="false"
              placeholder="Вкажіть розмір знижки (%)"
            />
          </div>
        </div>
      </IQOS>
      <div class="container-box iqos-static flex-row">
        <DashboardButton variant="white" class="w-35">Скасувати</DashboardButton
        ><DashboardButton variant="standart" class="w-35"
          >Створити</DashboardButton
        >
      </div>
    </div>
  </div>
</template>
<script>
import IQOS from "@/components/IQOS.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import DashboardButton from "@/components/DashboardButton.vue";

export default {
  components: {
    IQOS,
    BlackSelect,
    DashboardButton,
  },
};
</script>
<style scoped>
.compagin-pop-up-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-row {
  display: flex;
  align-items: center;
}
.line-split {
  font-size: 4vh;
  color: #ededed;
  margin: 0 3.3333333333333335vh;
}
.container-box.iqos-static.flex-row {
  justify-content: space-between;
}
.w-35 {
  width: 35%;
}
.pop-up-message {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
}
.mb-10 {
  margin-bottom: 1.1111111111111112vh;
}
</style>
